import{getColorFromString as t,updateA as r}from"@fluentui/react";const o=(o,e)=>{const n=t(o);return n?r(n,e).str:""};export{o as applyOpacityToHexColor};
//# sourceMappingURL=style-utils.js.map
